/**
 * Header the browser sets on a risk-event request to name the Fingerprint
 * identification event it ran for that request. The server looks the event up
 * with the Fingerprint secret key rather than trusting anything else the
 * browser says about the device.
 */
export const FINGERPRINT_EVENT_HEADER = "x-fp-event-id";
